import i18n from '@/i18n'

export const namespaced = true

export const state = {
  title: '',
  content: '',
  model: false,
  color: 'primary',
  resolved: false,
  rejected: false,
}

export const mutations = {
  toggle: (state: { model: boolean }, payload: boolean) =>
    (state.model = payload),
  setTitle: (state: { title: string }, payload: string) =>
    (state.title = payload),
  setContent: (state: { content: string }, payload: string) =>
    (state.content = payload),
  setColor: (state: { color: string }, payload: string) =>
    (state.color = payload),
  reject: (state: { rejected: boolean }) => (state.rejected = true),
  resolve: (state: { resolved: boolean }) => (state.resolved = true),
}

export const actions = {
  alert: (
    context: any,
    payload: { title: string; content: string; color: string },
  ) => {
    const data = Object.assign(
      {
        title: i18n.t('confirm'),
        content: i18n.t('confirm-to-perform-action'),
        color: 'primary',
      },
      payload,
    )
    context.commit('setTitle', data.title)
    context.commit('setContent', data.content)
    context.commit('setColor', data.color)
    context.commit('toggle', true)
    return new Promise(resolve => {
      const interval = setInterval(() => {
        if (context.state.resolved) {
          resolve(true)
          context.state.resolved = false
          clearInterval(interval)
        } else if (context.state.rejected) {
          resolve(false)
          context.state.rejected = false
          clearInterval(interval)
        }
      }, 100)
    })
  },
}
